import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE =
  "getPENDINGCONFIRMATIONORDERSTableStructure";
export const UPDATE_TABLE_DATA = "getPENDINGCONFIRMATIONORDERSTableData";
export const EXPORT_TABLE_DATA = "exportPENDINGCONFIRMATIONORDERSTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setPENDINGCONFIRMATIONORDERSTableStructure";
export const SET_TABLE_DATA = "setPENDINGCONFIRMATIONORDERSTableData";
export const SET_TABLE_FILTER = "setPENDINGCONFIRMATIONORDERSTableFilter";
export const SET_FILTER_CHANGE = "setPENDINGCONFIRMATIONORDERSFilterChange";
export const SET_TABLE_PAGE = "setPENDINGCONFIRMATIONORDERSTablePage";
export const SET_TABLE_PERPAGE = "setPENDINGCONFIRMATIONORDERSTablePerPage";
export const SET_TABLE_SORTBY = "setPENDINGCONFIRMATIONORDERSTableSortBy";
export const SET_TABLE_SORTORDER = "setPENDINGCONFIRMATIONORDERSTableSortOrder";
export const SET_EXPORT_LINK = "setPENDINGCONFIRMATIONORDERSExportLink";

const state = {
  queryObject: {},
  export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  /**
   * for table title, descripton
   * */
  getPENDINGCONFIRMATIONORDERSTableProperties(state) {
    return state.table_structure.properties;
  },
  /**
   * for table permissions
   **/
  getPENDINGCONFIRMATIONORDERSTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getPENDINGCONFIRMATIONORDERSTableState(state) {
    return state.table_state;
  },
  getPENDINGCONFIRMATIONORDERSTableHeaders(state) {
    return state.table_structure.columns;
  },

  getPENDINGCONFIRMATIONORDERSTableFilters(state) {
    return state.table_structure.filters;
  },

  getPENDINGCONFIRMATIONORDERSTableData(state) {
    return state.table_data.data;
  },

  getPENDINGCONFIRMATIONORDERSExportUrl(state) {
    return state.export_link;
  },
  getPENDINGCONFIRMATIONORDERSCallStatuses(state) {
    // console.log(state, state.table_structure.call_statuses[0]);
    return state.table_structure.call_statuses[0];
  },
  getPENDINGCONFIRMATIONORDERSUploadType(state) {
    return state.table_structure.type;
  },
  getPENDINGCONFIRMATIONORDERSExtraData(state) {
    return state.table_structure.reason_data;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    return new Promise((resolve) => {
      ApiService.post("/order_management/pending_confirmation_orders")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post(
        "/order_management/pending_confirmation_orders/datatable",
        payload
      )
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);
          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post(
        "/order_management/pending_confirmation_orders/export",
        payload
      )
        .then(({ data }) => {
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    // console.log("order state of filter update", filter);
    state.table_state.filters = filter;
  },

  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
